import angular from 'angular';
import '../shared.module';
import { timeAgo } from '../../core/helpers/date.helper';

angular.module('app.shared').filter('cpTimeago', () => (value) => (value ? timeAgo(value) : ''));
